// extracted by mini-css-extract-plugin
module.exports = {"full":"Titre_full__1s30B","titre":"Titre_titre__CtJmp"};